// import React from 'react'
// import { Route, Routes, useLocation } from 'react-router-dom'
// import PublicRoute from './PublicRoute'
// import ForgotPassword from '../pages/auth/ForgotPassword'
// import LoginOTP from '../pages/auth/LoginOTP'
// import SetPassword from '../pages/auth/SetPassword'
// import Login from '../pages/auth/login'
// import ProtectedRoute from './ProtectedRoute'
// import Layout from '../components/Layout'
// import UserDetails from '../pages/app-user'
// import Settings from '../pages/settings'
// import ReportsAnalytics from '../pages/data-reports/report-and-analytics'
// import SupportTicket from '../pages/support-ticket'
// import UserList from '../pages/user-management/user-list'
// import Roles from '../pages/user-management/roles'
// import Notification from '../pages/notification'
// import { ContextProvider } from '../context/appContext'
// import NotificationDetail from '../pages/notification/notificationDetails.tsx'
// import LoanAndInvestment from '../pages/loan-and-invetment/page'
// const AuthWrapper = ({ children }: { children: React.ReactNode }) => {
//     const location = useLocation()
//     const authRoutes = ['/', '/forgot-password', '/login-otp', '/set-password']
//     const isAuthRoute = authRoutes.includes(location.pathname)

//     return (
//       <div className={isAuthRoute ? 'auth-bg' : ''}>
//         {children}
//       </div>
//     )
//   }

// const router = () => {
//   return (
//     <ContextProvider>

//     <AuthWrapper>
//         <Routes>
//           {/* Public Routes - Login & Auth Pages */}
//           <Route element={<PublicRoute />}>
//             <Route path="/" element={<Login />} />
//             <Route path="/forgot-password" element={<ForgotPassword />} />
//             <Route path="/login-otp" element={<LoginOTP />} />
//             <Route path="/set-password" element={<SetPassword />} />
//           </Route>

//           {/* Protected Routes - App Pages */}
//           <Route element={<ProtectedRoute />}>
//             <Route element={<Layout />}>
//               <Route path="/user-lists" element={<UserDetails />} />
//               <Route path="/app-users" element={<UserDetails />} />
//               <Route path="/reports-analytics" element={<ReportsAnalytics />} />
//               <Route path="/loan-and-investment" element={<LoanAndInvestment />} />

//               <Route path="/support-ticket" element={<SupportTicket />} />
//               <Route path="/user-management/user-list" element={<UserList />} />
//               <Route path="/user-management/roles" element={<Roles />} />
//               <Route path="/notifications" element={<Notification />} />
//               {/* <Route path="/" element={<Notifications />} /> */}
//               <Route path="/notifications/:id" element={<NotificationDetail />} />
//               <Route path="/settings" element={<Settings />} />
//             </Route>
//           </Route>
//         </Routes>
//       </AuthWrapper>
//     </ContextProvider>

//   )
// }

// export default router

import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import PublicRoute from "./PublicRoute";
import ProtectedRoute from "./ProtectedRoute";
import Layout from "../components/Layout";
import { ContextProvider } from "../context/appContext";

// Lazy loaded pages
const Login = lazy(() => import("../pages/auth/login"));
const ForgotPassword = lazy(() => import("../pages/auth/ForgotPassword"));
const LoginOTP = lazy(() => import("../pages/auth/LoginOTP"));
const SetPassword = lazy(() => import("../pages/auth/SetPassword"));

const UserDetails = lazy(() => import("../pages/app-user"));
const Settings = lazy(() => import("../pages/settings"));
const ReportsAnalytics = lazy(
  () => import("../pages/data-reports/report-and-analytics")
);
const LoanAndInvestment = lazy(
  () => import("../pages/loan-and-invetment/page")
);
const SupportTicket = lazy(() => import("../pages/support-ticket"));
const UserList = lazy(() => import("../pages/user-management/user-list"));
const Roles = lazy(() => import("../pages/user-management/roles"));
const Notification = lazy(() => import("../pages/notification"));
const NotificationDetail = lazy(
  () => import("../pages/notification/notificationDetails.tsx")
);
const AuthWrapper = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const authRoutes = ["/login", "/forgot-password", "/login-otp", "/set-password"];
  const isAuthRoute = authRoutes.includes(location.pathname);

  return (
    <div
      // className={isAuthRoute ? 'auth-bg' : ''}
      style={{ minHeight: '100vh', overflowY: 'auto' }}
    >
      {children}
    </div>
  );
};

const Router = () => {
  return (
    <ContextProvider>
      <AuthWrapper>
        <Suspense fallback={<div className="text-center py-5">Loading...</div>}>
          <Routes>
            {/* Public Routes */}
            {/* <Route element={<PublicRoute />}>
              <Route path="/" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/login-otp" element={<LoginOTP />} />
              <Route path="/set-password" element={<SetPassword />} />
            </Route> */}

            <Route element={<PublicRoute />}>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/login-otp" element={<LoginOTP />} />
              <Route path="/set-password" element={<SetPassword />} />
            </Route>
            {/* Protected Routes */}
            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                {/* <Route path="/user-lists" element={<UserDetails />} /> */}
                <Route path="/app-users" element={<UserDetails />} />
                <Route
                  path="/reports-analytics"
                  element={<ReportsAnalytics />}
                />
                <Route
                  path="/loan-and-investment"
                  element={<LoanAndInvestment />}
                />
                <Route path="/support-ticket" element={<SupportTicket />} />
                <Route
                  path="/user-management/user-list"
                  element={<UserList />}
                />
                <Route path="/user-management/roles" element={<Roles />} />
                <Route path="/notifications" element={<Notification />} />
                <Route
                  path="/notifications/:id"
                  element={<NotificationDetail />}
                />
                <Route path="/settings" element={<Settings />} />
              </Route>
            </Route>
          </Routes>
        </Suspense>
      </AuthWrapper>
    </ContextProvider>
  );
};

export default Router;
